export const CatalogServices = {
  en: {
    'Search categories and services…': 'Search folders and services…',
    'Expand all': 'Expand all',
    'Collapse tree': 'Collapse',
    'No results.': 'No results.',
    'No selection': 'No selection',
    Filters: 'Filters',
    Any: 'Any',
    Status: 'Status',
    'Reset filters': 'Reset filters',
    'Select a category or service from the tree on the left to see details.':
      'Select a folder or service from the tree on the left to see details.',
    'Create Category': 'Create Folder',
    'Create Root Category': 'Create Root Folder',
    'Create Subcategory': 'Create Subfolder',
    'Category name': 'Folder name',
    'Parent category': 'Parent folder',
    'Edit Category': 'Edit Folder',
    'Create subcategory': 'Create subfolder',
    Rename: 'Rename',
    'Maximum category depth': 'Maximum nesting depth reached',
    'Category not empty': 'Folder is not empty',
    'Confirm deletion': 'Confirm deletion',
    'Delete category confirm': 'Delete this folder? This cannot be undone.',
    'Category created': 'Folder created',
    'Category updated': 'Folder updated',
    'Category archived': 'Folder archived',
    'Category restored': 'Folder restored',
    'Category deleted': 'Folder deleted',
    'Move to': 'Move to…',
    Move: 'Move',
    'Move Category': 'Move Folder',
    'Move Service': 'Move Service',
    'Select destination category': 'Select destination folder',
    'Cannot move category depth':
      'Cannot move here — maximum nesting depth would be exceeded',
    'Category moved': 'Folder moved',
    'Service moved': 'Service moved',
    Services: 'Services',
    Subcategories: 'Subfolders',
    'This category is empty': 'This folder is empty',
    'direct services': 'direct services',
    'services total': 'services total',
    'Drag to reorder': 'Drag to reorder',
    'Add service': 'Add service',
    'Create Service': 'Create Service',
    'Edit Service': 'Edit Service',
    Category: 'Folder',
    'Business direction': 'Business direction',
    Duration: 'Duration',
    'Duration, minutes': 'Duration, min',
    minutes: 'min',
    'Cost price': 'Cost price',
    'Specialist payout (temporary)': 'Specialist payout (temporary)',
    'Price change reason': 'Price change reason',
    'Requires specialist': 'Requires specialist',
    'Booking type': 'Booking type',
    'Booking type none': 'Not bookable',
    'Booking type personal': 'Personal',
    'Booking type group': 'Group',
    'Booking type event': 'Event',
    'Price history': 'Price history',
    'No price changes': 'No price changes',
    Service: 'Service',
    'Service created': 'Service created',
    'Service updated': 'Service updated',
    'Service archived': 'Service archived',
    'Service restored': 'Service restored',
    'Service deleted': 'Service deleted',
    'Delete service confirm': 'Delete this service? This cannot be undone.',
    'Service category hint':
      'Folder for organising services into a tree structure. Used for sorting in the admin UI and for folder-level discounts (in cards).',
    'Business direction hint':
      "The business direction determines which P&L report segment this service's revenue falls into. For example: «Group classes», «Personal training», «Massages».",
    'Duration hint':
      'How long the service takes to provide. Used in the schedule calendar and when planning sessions.',
    'Receipt name': 'Receipt name',
    'Receipt name hint':
      'Line name on the fiscal receipt. Empty = the service name is used.',
    'Cost price hint':
      'Planned cost of the service (trainer salary, consumables) for margin calculation in reports. Does not affect the sale price. Not shown to the client.',
    'Specialist payout (temporary) hint':
      'A flat amount paid to the specialist for each use of this service. Written to the «Specialist payouts (temporary)» report at the moment of use; changing it later does not affect payouts already recorded. Empty or 0 = no payout. Temporary until the salary module.',
    'Locations hint':
      'Locations where this service is available for sale and provision. For other locations the service is not shown in POS and the calendar.',
    'Requires specialist hint':
      'Whether the service is delivered by a specialist. If it is, the specialist list below is mandatory: only the listed specialists can deliver it, be booked for it or be put on a schedule. For example: massage — yes (a masseur is needed); gym entry — no (any administrator).',
    'Booking type hint':
      'Controls whether and how this service can be booked. «Personal» and «Group» require a specialist and a duration that is a multiple of 30 minutes; «Event» carries its own start and end time. «Not bookable» keeps the service sellable but out of the booking flow.',
    'Add specialists': 'Add specialists',
    'Specify staff member': 'Specify staff member',
    Remove: 'Remove',
    'Selling permissions': 'Selling permissions',
    Specialists: 'Specialists',
    'Anyone with sales permission can sell': 'Anyone with sales permission',
    'No specialists selected': 'Nobody selected.',
    'No specialists warning':
      'Without specialists the service cannot be booked or scheduled.',
    'No specialists available': 'No specialists available.',
    'Selling permissions hint':
      'Who among the staff can sell this service. If empty — everyone with the sell permission. If specific employees or roles are listed — only them. Useful for services only management can sell (e.g. special discounted rates).',
    'Specialists hint':
      'Only specialists provide the service. Default is nobody; an empty list means it cannot be booked or scheduled. Only staff with the Specialist flag can be picked; a folder ticks its specialists in bulk, the service still stores individual employees.',
    General: 'General',
    Booking: 'Booking',
    'Requires specialist forced hint':
      'A personal or group service is always delivered by a specialist — the flag stays on while that booking type is selected.',
    'Internal notes': 'Internal notes',
    'Internal notes hint':
      'A note for the staff only. Never shown to the client, anywhere.',
    'Client description': 'Client description',
    'Client description hint':
      'The text a client sees for this service in the booking flow. Supports formatting.',
    'Booking image': 'Booking image',
    'Booking image hint':
      'The picture a client sees for this service in the booking flow.',
    'Booking color': 'Booking color',
    'Booking color hint':
      "The colour this service's bookings are drawn with on the admin calendar.",
    'Custom fields': 'Custom fields',
    'Custom fields hint':
      'Extra questions asked when booking this service — for example the age of the children for a family session. The answers land on the booking.',
    'No custom fields yet': 'No custom fields yet.',
    'Add custom field': 'Add field',
    'Field label': 'Field label',
    'Field type': 'Field type',
    'Custom field type text': 'Text',
    'Custom field type number': 'Number',
    'Custom field type dropdown': 'Drop-down list',
    'Drop-down list items': 'Drop-down list items',
    'Enter each new value on a new line': 'Enter each value on a new line',
    'Required field': 'Required',
    'Move up': 'Move up',
    'Move down': 'Move down',
  },
  uk: {
    'Search categories and services…': 'Пошук папок та послуг…',
    'Expand all': 'Розгорнути все',
    'Collapse tree': 'Згорнути',
    'No results.': 'Нічого не знайдено.',
    'No selection': 'Нічого не вибрано',
    Filters: 'Фільтри',
    Any: 'Будь-який',
    Status: 'Статус',
    'Reset filters': 'Скинути фільтри',
    'Select a category or service from the tree on the left to see details.':
      'Виберіть папку або послугу в дереві ліворуч, щоб побачити деталі.',
    'Create Category': 'Створити папку',
    'Create Root Category': 'Створити кореневу папку',
    'Create Subcategory': 'Створити підпапку',
    'Category name': 'Назва папки',
    'Parent category': 'Батьківська папка',
    'Edit Category': 'Редагувати папку',
    'Create subcategory': 'Створити підпапку',
    Rename: 'Перейменувати',
    'Maximum category depth': 'Досягнуто максимальної глибини вкладеності',
    'Category not empty': 'Папка не порожня',
    'Confirm deletion': 'Підтвердьте видалення',
    'Delete category confirm': 'Видалити цю папку? Цю дію не можна скасувати.',
    'Category created': 'Папку створено',
    'Category updated': 'Папку оновлено',
    'Category archived': 'Папку заархівовано',
    'Category restored': 'Папку відновлено',
    'Category deleted': 'Папку видалено',
    'Move to': 'Перемістити…',
    Move: 'Перемістити',
    'Move Category': 'Перемістити папку',
    'Move Service': 'Перемістити послугу',
    'Select destination category': 'Виберіть цільову папку',
    'Cannot move category depth':
      'Неможливо перемістити сюди — буде перевищено максимальну глибину вкладеності',
    'Category moved': 'Папку переміщено',
    'Service moved': 'Послугу переміщено',
    Services: 'Сервіси',
    Subcategories: 'Підпапки',
    'This category is empty': 'Ця папка порожня',
    'direct services': 'послуг безпосередньо',
    'services total': 'послуг загалом',
    'Drag to reorder': 'Перетягніть, щоб змінити порядок',
    'Add service': 'Додати послугу',
    'Create Service': 'Створити послугу',
    'Edit Service': 'Редагування послуги',
    Category: 'Папка',
    'Business direction': 'Напрямок діяльності',
    Duration: 'Тривалість',
    'Duration, minutes': 'Тривалість, хв',
    minutes: 'хв',
    'Cost price': 'Собівартість',
    'Specialist payout (temporary)': 'Виплата спеціалісту (тимчасово)',
    'Price change reason': 'Причина зміни ціни',
    'Requires specialist': 'Потрібен спеціаліст',
    'Booking type': 'Тип бронювання',
    'Booking type none': 'Не бронюється',
    'Booking type personal': 'Персональне',
    'Booking type group': 'Групове',
    'Booking type event': 'Подія',
    'Price history': 'Історія цін',
    'No price changes': 'Змін ціни немає',
    Service: 'Послуга',
    'Service created': 'Послугу створено',
    'Service updated': 'Послугу оновлено',
    'Service archived': 'Послугу заархівовано',
    'Service restored': 'Послугу відновлено',
    'Service deleted': 'Послугу видалено',
    'Delete service confirm': 'Видалити цю послугу? Цю дію не можна скасувати.',
    'Service category hint':
      'Папка для організації послуг у деревоподібну структуру. Використовується для сортування в admin UI та для знижок на рівні папки (в картках).',
    'Business direction hint':
      'Напрямок діяльності визначає в який сегмент звіту про прибуток (P&L) потрапляє виручка від цієї послуги. Наприклад: «Групові заняття», «Індивідуальні тренування», «Масажі».',
    'Duration hint':
      'Тривалість надання послуги. Використовується в календарі розкладу та при плануванні занять.',
    'Receipt name': 'Назва в чеку',
    'Receipt name hint':
      'Назва позиції у фіскальному чеку. Порожнє = використовується назва послуги.',
    'Cost price hint':
      'Планова собівартість послуги (зарплата тренера, витратні матеріали) для розрахунку маржинальності в звітах. Не впливає на ціну продажу. Не показується клієнту.',
    'Specialist payout (temporary) hint':
      'Фіксована сума, що нараховується спеціалісту за кожне використання цієї послуги. Записується у звіт «Виплати спеціалістам (тимчасово)» в момент використання; подальша зміна суми не впливає на вже записані виплати. Порожнє або 0 = без виплати. Тимчасово, до появи модуля зарплат.',
    'Locations hint':
      'Локації де доступна ця послуга для продажу та надання. Для інших локацій послуга не відображається в POS та календарі.',
    'Requires specialist hint':
      'Чи надає послугу спеціаліст. Якщо так — список спеціалістів нижче обов’язковий: тільки вказані спеціалісти можуть надавати послугу, бути заброньованими на неї чи поставленими в графік. Наприклад: масаж — так (потрібен масажист); вхід у зал — ні (будь-який адміністратор).',
    'Booking type hint':
      'Визначає, чи можна бронювати цю послугу та яким чином. «Персональне» та «Групове» потребують спеціаліста і тривалості, кратної 30 хвилинам; «Подія» має власний час початку та завершення. «Не бронюється» лишає послугу доступною для продажу, але поза потоком бронювання.',
    'Add specialists': 'Додати спеціалістів',
    'Specify staff member': 'Вказати співробітника',
    Remove: 'Видалити',
    'Selling permissions': 'Права на продаж',
    Specialists: 'Спеціалісти',
    'Anyone with sales permission can sell': 'Будь-хто з правом продажу',
    'No specialists selected': 'Нікого не вибрано.',
    'No specialists warning':
      'Без спеціалістів послугу не можна забронювати чи поставити в графік.',
    'No specialists available': 'Спеціалістів немає.',
    'Selling permissions hint':
      'Хто з персоналу може продавати цю послугу. Якщо порожнє — всі з правом продажу. Якщо вказані конкретні співробітники або ролі — тільки вони. Корисно для послуг, які може продавати тільки керівництво (наприклад, спеціальні знижкові тарифи).',
    'Specialists hint':
      'Послугу проводять лише спеціалісти. За замовчуванням — нікого; порожній список = послугу не можна забронювати чи поставити в графік. Вибрати можна лише співробітників з ознакою «Спеціаліст»; папка відмічає своїх спеціалістів гуртом, у послузі зберігаються окремі співробітники.',
    General: 'Загальне',
    Booking: 'Бронювання',
    'Requires specialist forced hint':
      'Персональну або групову послугу завжди проводить спеціаліст — поки вибрано цей тип бронювання, ознака лишається увімкненою.',
    'Internal notes': 'Внутрішні нотатки',
    'Internal notes hint':
      'Нотатка лише для персоналу. Клієнту не показується ніде.',
    'Client description': 'Опис для клієнта',
    'Client description hint':
      'Текст, який клієнт бачить для цієї послуги у флоу бронювання. Підтримує форматування.',
    'Booking image': 'Зображення для бронювання',
    'Booking image hint':
      'Зображення, яке клієнт бачить для цієї послуги у флоу бронювання.',
    'Booking color': 'Колір бронювання',
    'Booking color hint':
      'Колір, яким бронювання цієї послуги малюються в календарі адміністратора.',
    'Custom fields': 'Додаткові поля',
    'Custom fields hint':
      'Додаткові питання, які ставляться під час бронювання цієї послуги — наприклад, вік дітей для сімейного заняття. Відповіді зберігаються в бронюванні.',
    'No custom fields yet': 'Додаткових полів ще немає.',
    'Add custom field': 'Додати поле',
    'Field label': 'Назва поля',
    'Field type': 'Тип поля',
    'Custom field type text': 'Текст',
    'Custom field type number': 'Число',
    'Custom field type dropdown': 'Випадний список',
    'Drop-down list items': 'Елементи випадного списку',
    'Enter each new value on a new line': 'Кожне значення — з нового рядка',
    'Required field': "Обов'язкове",
    'Move up': 'Вгору',
    'Move down': 'Вниз',
  },
};
